import PaperClip from './PaperClip';

export default PaperClip;
